/**
 * User: Nikolai Gorte * Date: 23.11.23 * Time: 09:31
 */
import React, { useState } from 'external/react';
import PropTypes from 'external/prop-types';
import { Badge, Dropdown } from 'external/react-bootstrap';

export const FilterDropdown = ({
  count,
  children,
  title = 'Filter auswählen',
  iconClassName = 'fa fa-filter',
  className = ''
}) => {
  const [ isOpen, setIsOpen ] = useState(false);

  const onToggle = (show, e, metadata) => {
    // prevent from closing when clicking an item
    if (metadata.source !== 'select') {
      setIsOpen(show);
    }
  };

  return (
    <Dropdown
      show={isOpen}
      className={`filter-dropdown ${className}`}
      onToggle={onToggle}
    >
      <Dropdown.Toggle id="filter-toggle">
        <div className="d-flex flex-row align-items-center">
          <i className={iconClassName} aria-hidden="true"/>
          {title}
          {
            count > 0 && <Badge pill variant="primary">{count}</Badge>
          }
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

FilterDropdown.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  children: PropTypes.node,
  count: PropTypes.number,
};



// WEBPACK FOOTER //
// ./js/components/FilterDropdown.jsx